<template>
  <!-- else 근무 시간표일때  -->
    <div class="inner-box">

      <el-form size="mini" :model="form" ref="catInfoForm" class="components">

        <el-row>
          <el-form-item label="오전" style="color: red;">
            <el-row>
              <el-col>
                <el-col :span="4">
                  <el-form-item label="월">
                    <el-checkbox v-model="form.monMorningYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="화">
                    <el-checkbox v-model="form.tueMorningYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="수">
                    <el-checkbox v-model="form.wedMorningYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="목">
                    <el-checkbox v-model="form.thuMorningYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="금">
                    <el-checkbox v-model="form.friMorningYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="토">
                    <el-checkbox v-model="form.satMorningYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="오후" style="color: red;">
            <el-row>
              <el-col>
                <el-col :span="4">
                  <el-form-item label="월">
                    <el-checkbox v-model="form.monAfterNoonYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="화">
                    <el-checkbox v-model="form.tueAfterNoonYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="수">
                    <el-checkbox v-model="form.wedAfterNoonYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="목">
                    <el-checkbox v-model="form.thuAfterNoonYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="금">
                    <el-checkbox v-model="form.friAfterNoonYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="토">
                    <el-checkbox v-model="form.satAfterNoonYn" true-label="Y" false-label="N" label="근무" size="medium" style="width: 100%;" border/>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>

      </el-form>

      </div>
</template>

<script>
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

export default {
  name: "Timetable",
  props: ['custParam','selectId'],
  data() {
    return {
      form: {
        friAfterNoonYn: "",
        friMorningYn: "",
        monAfterNoonYn: "",
        monMorningYn: "",
        satAfterNoonYn: "",
        satMorningYn: "",
        sunAfterNoonYn: "",
        sunMorningYn: "",
        thuAfterNoonYn: "",
        thuMorningYn: "",
        tueAfterNoonYn: "",
        tueMorningYn: "",
        wedAfterNoonYn: "",
        wedMorningYn: "",
      },
      tableData : [],
      tapName: "default",
    };
  },
  methods: {
    setInfo() {
      Object.assign(this.form, this.custParam);
    },
    beforeMount() {
    },
    mounted() {
    },
    created() {

    },
    createTable(){
      this.tableData = [
        {
          type: '오전',
          // mon: this.form.monMorningYn,
          // tue: this.form.tueMorningYn,
          // wed: this.form.wedMorningYn,
          // thu: this.form.thuMorningYn,
          // fri: this.form.friMorningYn,
          // sat: this.form.satMorningYn
        },
        // {
        //   type: '오후',
        //   // mon: this.form.monAfterNoonYn,
        //   // tue: this.form.tueAfterNoonYn,
        //   // wed: this.form.wedAfterNoonYn,
        //   // thu: this.form.thuAfterNoonYn,
        //   // fri: this.form.friAfterNoonYn,
        //   // sat: this.form.satAfterNoonYn
        // }
      ]
    }
  },
  watch: {
    custParam() {
      this.setInfo();
      this.createTable();
    },
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
.el-select {
  width: 100%;
}

.el-row {
  border-bottom: 1px solid #d7d7d7;
  &:last-child {
    border-bottom: none;
  }
}

.el-form {
  border: 1px solid #d7d7d7 !important;
  padding: 10px 25px 10px 25px;
  border-radius: 5px;
}
</style>